import { PERMISSION_TYPES, isCustomerContactRole } from "@routebot/constants";
import { isInternationalTheme } from "config/ConfigUtils";

/**
 * /start is a RouteBot page. Servistesin never opens it. Driver-only and
 * customer-contact accounts keep their existing homes.
 */
export const canUseStartExperience = ({
  isLoggedIn = false,
  permissions = {},
  role,
  isInternational = isInternationalTheme(),
} = {}) => {
  if (!isInternational) return false;
  if (!isLoggedIn) return true;
  if (permissions?.[PERMISSION_TYPES.ACCESS_TO_TRACK_VEHICLE_ONLY]) return false;
  if (isCustomerContactRole(role)) return false;
  return true;
};

export const getStartDeniedRedirect = ({ permissions = {}, role, isInternational = true } = {}) => {
  if (permissions?.[PERMISSION_TYPES.ACCESS_TO_TRACK_VEHICLE_ONLY]) return "/live";
  if (isCustomerContactRole(role)) return "/portal/requests";
  if (!isInternational) return "/users";
  return "/login";
};
